import React, { PropsWithChildren } from 'react'
import { InfoIcon } from '@chakra-ui/icons'
import { Box, Flex } from '@chakra-ui/react'
import { PatientFieldsFragment } from '~graphql/generated/graphql'
import ExportSelectWrapper from '../export-select-wrapper'
import MessageDetailsInfo from '../user-message/message-info'

interface Props {
    patient?: Pick<PatientFieldsFragment, 'name'> | null
    isPreview?: boolean
    showLocationTag?: boolean
}

export default function SystemMessageWrapper({
    patient,
    isPreview,
    showLocationTag,
    children,
}: PropsWithChildren<Props>) {
    return (
        <ExportSelectWrapper>
            <Box w="full">
                <Box
                    px={3}
                    py={2}
                    fontSize="sm"
                    bg={isPreview ? 'orange.50' : 'gray.100'}
                    color="gray.500"
                    borderRadius="xl"
                    borderWidth={1}
                    borderColor={isPreview ? 'orange.100' : 'gray.200'}
                    overflowWrap="anywhere"
                    overflow="hidden"
                    opacity={showLocationTag ? 0.7 : 1}
                    transition="opacity 0.2s ease-in-out"
                    _hover={
                        showLocationTag
                            ? {
                                  opacity: 1,
                              }
                            : {}
                    }
                >
                    <Flex>
                        <InfoIcon
                            boxSize="18px"
                            mr={3}
                            mt={1}
                            color={isPreview ? 'orange.500' : 'blue.500'}
                        />
                        {children}
                    </Flex>
                    <MessageDetailsInfo />
                </Box>
            </Box>
        </ExportSelectWrapper>
    )
}
